<template>
  <div class="container-header">
    <div
        :class="['header', isSticky ? 'header--sticky' : '']"
    >
      <div
        v-if="!isHidden"
        class="header__container"
      >
        <div class="header__content">
          <div class="header__left">
            <DefaultSocialList
              :items="socialList"
            />
          </div>
          <div
            :class="searchInputActive ? 'header__center--search-active' : ''"
            class="header__center"
          >
            <DefaultMainLogo :link="props.logoLink" />
          </div>
          <div class="header__menu header__menu--sticky">
            <ul class="scrollbar-hide">
              <li v-for="(menuItem) in mainMenuItems" :key="menuItem.url">
                <NuxtLink :to="`/${menuItem.url}`">{{ menuItem.name }}</NuxtLink>
              </li>
            </ul>
          </div>
          <div
            :class="searchInputActive ? 'w-full' : 'w-auto'"
            class="header__right flex items-center justify-end"
          >
            <div
              class="right_menu w-full relative"
            >
              <!-- Subscription button -->
              <DefaultHeaderLinkButton
                v-if="showSubscription"
                class="header__sub-btn transition-240"
                :class="searchInputActive ? '!hidden' : '!block'"
                :link="magazineSubscriptionLink"
                :label="$t('header.buy_subscription')"
                :label-mobile="$t('header.buy_subscription--shorten')"
              />
              <!-- Newsletter button -->
              <DefaultHeaderLinkButton
                v-if="showNewsletterButton"
                class="header__sub-btn transition-240"
                :class="searchInputActive ? '!hidden' : '!block'"
                :link="newsletterLink"
                :label="$t('header.newsletter')"
                :label-mobile="$t('header.newsletter--shorten')"
              />
              <!-- Logged user -->
              <DefaultLoggedUser
                v-if="!searchInputActive"
                class="logged-user"
                :class="{ 'logged-user--space': showSubscription || showNewsletterButton}"
              />
              <div
                :class="searchInputActive ? 'grow' : ''"
                class="relative pr-px"
                @click.stop
              >
                <form
                  :class="searchInputActive ? '' : 'search--hidden'"
                  class="search" method="GET" action="/" @submit.prevent="formSubmit"
                >
                  <input
                    class="input"
                    ref="searchInput"
                    v-model="inputModel"
                    type="search"
                    name="q"
                    :placeholder="$t('header.fulltext_placeholder')"
                  />
                  <button
                    v-if="inputModel.length"
                    :class="searchInputActive ? 'opacity-0' : 'hidden'"
                    class="search__btn"
                    type="submit"
                  >
                    <DefaultIconsSearch />
                  </button>
                  <button v-if="inputModel.length" class="search__btn search__btn--cancel" @click="resetSearch">
                    <DefaultIconsCross />
                  </button>
                </form>
                <!-- search icon -->
                <button
                  @click.stop="openSearch"
                  :class="searchInputActive ? 'search__btn--outside' : 'search__btn--to-show'"
                  class="search__btn"
                >
                  <DefaultIconsSearch />
                </button>
              </div>
              <!-- hamburger / menu icon -->
              <button
                @click.stop="handleHamburgerClick"
                class="header__hamburger"
              >
                <div class="m-2 w-6 h-6 flex items-center justify-center relative">
                  <span
                    :class="showHamburgerCrossIcon ? 'w-8/12 translate-y-0 rotate-45' : '-translate-y-1.5 w-full'"
                    class="transition-240 transform h-0.5 rounded bg-current absolute"
                  ></span>
                  <span
                    :class="showHamburgerCrossIcon ? 'w-8/12 opacity-0 translate-x-3' : 'opacity-100 w-full'"
                    class="transition-240 transform h-0.5 rounded bg-current absolute"
                  ></span>
                  <span
                    :class="showHamburgerCrossIcon ? 'w-8/12 translate-y-0 -rotate-45' : 'translate-y-1.5 w-full'"
                    class="transition-240 transform h-0.5 rounded bg-current absolute"
                  ></span>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="header__menu">
          <ul class="scrollbar-hide">
            <li v-for="(menuItem) in mainMenuItems" :key="menuItem.url">
              <NuxtLink :to="`/${menuItem.url}`">{{ menuItem.name }}</NuxtLink>
            </li>
          </ul>
        </div>
        <div class="header__waves">
          <svg viewBox="0 0 1080 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-32 0.720436V26.3951C-25.852 33.5251 -15.54 44.037 -8.16933 44.037C2.984 44.037 20.8773 19.9691 20.8773 19.9691C20.8773 19.9691 38.7667 44.036 49.9173 44.037C61.0707 44.037 78.9627 19.9691 78.9627 19.9691C78.9627 19.9691 96.856 44.037 108.009 44.037C119.161 44.036 137.052 19.9691 137.052 19.9691C137.052 19.9691 154.947 44.037 166.099 44.037C177.252 44.036 195.144 19.9691 195.144 19.9691C195.144 19.9691 213.037 44.036 224.189 44.037C235.343 44.037 253.239 19.9691 253.239 19.9691C253.239 19.9691 271.131 44.036 282.283 44.037C293.437 44.037 311.336 19.9691 311.336 19.9691C311.336 19.9691 329.228 44.036 340.381 44.037C351.535 44.037 369.432 19.9691 369.432 19.9691C369.432 19.9691 387.327 44.036 398.479 44.037C409.632 44.037 427.528 19.9691 427.528 19.9691C427.528 19.9691 445.425 44.037 456.579 44.037C467.732 44.036 485.627 19.9691 485.627 19.9691C485.627 19.9691 503.524 44.036 514.677 44.037C525.831 44.037 543.731 19.9691 543.731 19.9691C543.731 19.9691 561.628 44.037 572.781 44.037C583.935 44.037 601.832 19.9691 601.832 19.9691C601.832 19.9691 619.728 44.037 630.881 44.037C642.035 44.037 659.932 19.9691 659.932 19.9691C659.932 19.9691 677.831 44.036 688.984 44.037C700.139 44.037 718.04 19.9691 718.04 19.9691C718.04 19.9691 735.935 44.036 747.088 44.037C758.241 44.037 776.14 19.9691 776.14 19.9691C776.14 19.9691 794.035 44.037 805.188 44.037C816.341 44.037 834.236 19.9691 834.236 19.9691C834.236 19.9691 852.135 44.036 863.288 44.037C874.443 44.037 892.345 19.9691 892.345 19.9691C892.345 19.9691 910.243 44.036 921.396 44.037C932.551 44.037 950.451 19.9691 950.451 19.9691C950.451 19.9691 968.352 44.036 979.507 44.037C990.661 44.037 1008.57 19.9691 1008.57 19.9691C1008.57 19.9691 1026.46 44.036 1037.62 44.037C1048.77 44.038 1066.68 19.9691 1066.68 19.9691C1066.68 19.9691 1079.75 37.536 1090.52 42.647V0.720459L-32 0.720436Z" fill="#E8E765"/>
          </svg>
        </div>
      </div>
      <div
        :class="isMegamenuActive ? 'header__megamenu--active' : ''" class="header__megamenu"
      >
        <div class="megamenu" @click.stop>
          <div class="megamenu__main">
            <div class="hidden md:flex justify-between items-center gap-14">
              <DefaultMainLogo :link="props.logoLink" />
              <button
                @click="handleHamburgerClick"
                class="header__hamburger header__hamburger--megamenu"
              >
                <div class="m-2 w-6 h-6 flex items-center justify-center relative">
                  <span
                    :class="isMegamenuActive ? 'w-8/12 translate-y-0 rotate-45' : '-translate-y-1.5 w-full'"
                    class="transition-240 transform h-0.5 rounded bg-current absolute"
                  ></span>

                  <span
                    :class="isMegamenuActive ? 'w-8/12 opacity-0 translate-x-3' : 'opacity-100 w-full'"
                    class="transition-240 transform h-0.5 rounded bg-current absolute"
                  ></span>

                  <span
                    :class="isMegamenuActive ? 'w-8/12 translate-y-0 -rotate-45' : 'translate-y-1.5 w-full'"
                    class="transition-240 transform h-0.5 rounded bg-current absolute"
                  ></span>
                </div>
              </button>
            </div>
            <div>
              <form class="search search--megamenu" method="GET" action="/" @submit.prevent="formSubmit">
                <input
                  ref="searchInput2"
                  v-model="inputModel"
                  type="text"
                  name="q"
                  :placeholder="$t('header.fulltext_placeholder')"
                />
                <button class="search__btn" type="submit">
                  <DefaultIconsSearch />
                </button>
                <button v-if="inputModel.length" class="search__btn search__btn--cancel" @click="resetSearch">
                  <DefaultIconsCross />
                </button>
              </form>
            </div>
            <div class="header__menu">
              <ul class="scrollbar-hide">
                <li
                  v-for="(menuItem) in mainMenuItems"
                  :class="{ 'active': isSubmenuActive(menuItem.url) }"
                  :key="menuItem.url"
                  class="menu-item"
                >
                  <div
                    class="menu-item__action"
                    @click.prevent="toggleSubmenu($event, menuItem)"
                  >
                    <NuxtLink
                      :to="getMenuItemUrl(menuItem)"
                      :target="menuItem.target"
                      @click.stop="handleLinkClick(menuItem)"
                    >
                      {{ menuItem.name }}
                    </NuxtLink>
                    <button
                      :class="isSubmenuActive(menuItem.url) ? 'btn--active' : ''"
                      class="btn btn--chevron"
                    >

                      <DefaultIconsChevronRight/>
                    </button>
                  </div>

                  <ul
                    v-if="menuItem.items"
                    class="menu-item__container"
                    :style="{ maxHeight: isSubmenuActive(menuItem.url) ? getContainerHeight(menuItem.url) : undefined }"
                  >
                    <li
                      v-for="(subMenuItem) in menuItem.items"
                    >
                      <NuxtLink :to="getMenuItemUrl(subMenuItem)" :target="subMenuItem.target">{{ subMenuItem.name }}</NuxtLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="hr"></div>
            <div
              v-if="contactEmail"
              class="flex flex-col justify-between items-center gap-8"
            >
              <DefaultSocialList
                :items="socialList"
              />
              <div class="flex items-center sm:items-start gap-0 sm:gap-2 flex-col sm:flex-row">
                <div class="flex flex-row flex-nowrap justify-items-center">
                  <a :href="`mailto:${contactEmail}`" class="underline email">
                    {{ contactEmail }}
                  </a>
                </div>
              </div>
              <!-- Subscription button -->
              <DefaultHeaderLinkButton
                v-if="showSubscription"
                :link="magazineSubscriptionLink"
                :label="$t('header.buy_subscription')"
              />
              <!-- Newsletter button -->
              <DefaultHeaderLinkButton
                v-if="showNewsletterButton"
                :link="newsletterLink"
                :label="$t('header.newsletter')"
              />
            </div>
            <div
              v-if="showSubscription"
              class="megamenu__under-section adv-magazine"
            >
              <div class="" v-if="getCurrentEditionImageSrc()">
                <NuxtLink :to="magazineSubscriptionLink" target="_blank">
                  <!-- Dynamic image - get from article by currentEditionArticleId - loaded in layouts/default.vue-->
                  <img class="w-full object-cover" loading="lazy" :src="getCurrentEditionImageSrc()" :alt="$t('header.current_edition')">
                </NuxtLink>
              </div>
              <button class="btn btn--secondary mt-2">
                <NuxtLink :to="magazineSubscriptionLink" target="_blank">{{ $t('header.show_current_edition') }}</NuxtLink>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, nextTick } from "vue"
import type { PropType } from "vue"
import type { HeaderTranslations } from "~/libs/interfaces/Translations"
import type StaticMenuItem from "~/libs/interfaces/StaticMenuItem"
import {useStaticMenuConfig} from "~/composables/useStaticMenuConfig"
import {MenuHeaderConfig} from "~/config/MenuHeaderConfig"
import {useArticlesStore} from "~/stores/useArticlesStore"
import {ArticleStoreType} from "~/libs/constants/ArticleStoreType"
import {useHeaderConfig} from "~/composables/useHeaderConfig"

const props = defineProps({
  logoLink: { type: String, required: false, default: "/" },
  translations: { type: Object as PropType<HeaderTranslations>, required: false, default: {} },
  menuItems: { type: Array<StaticMenuItem>, required: false},
});

const route = useRoute()
const config = useRuntimeConfig()
const localePath = useLocalePath()
const contactEmail = config.public.contactEmail
const router = useRouter()

const { $listen } = useNuxtApp()

const articleCurrentEditionStore = useArticlesStore(ArticleStoreType.CURRENT_EDITION)

const mainMenuItems = computed(() => {
  if (props.menuItems && props.menuItems.length) {
    return props.menuItems
  }
  if (useStaticMenuConfig(MenuHeaderConfig).getConfig()) {
    return useStaticMenuConfig(MenuHeaderConfig).getConfig()
  }
  return []
})

const showSubscription = config.public.showSubscription || false
const showNewsletterButton = config.public.smartEmailing?.enabled && config.public.showNewsletterButton && !showSubscription
const newsletterLink = localePath({ name: "newsletter" })
const magazineSubscriptionLink = config.public.magazineSubscriptionLink
const showLogin = config.public.showLogin || false

const socialList = useSocialListConfig().getSocialList(true) || []

const isWeb = ref(false);
const isSticky = ref(false); // New ref for sticky class
const isHidden = ref(false);

let fulltext = ref(String(route.query.q || ""));
let inputModel = ref(fulltext.value);

const isMegamenuActive = ref(false);

const searchInput = ref<HTMLInputElement | null>(null)
const searchInputActive = ref(false)

const activeSubmenuId = ref<string | null>(null)
const containerHeights = ref<Record<string, string>>({})

const showHamburgerCrossIcon = computed(() => {
  return isMegamenuActive.value || searchInputActive.value
})

// Function to check if a submenu is active
const isSubmenuActive = (menuId: string): boolean => {
  return activeSubmenuId.value === menuId
}
// Function to get container height
const getContainerHeight = (menuId: string): string => {
  return containerHeights.value[menuId] || '0px'
}
// Function to toggle submenu
const toggleSubmenu = async (event: Event, menuItem: any) => {
  if (!menuItem.items) {
    // If no submenu, just navigate
    navigateTo(getMenuItemUrl(menuItem))
    return
  }

  const menuId = menuItem.url
  const isActive = isSubmenuActive(menuId)

  // Toggle active state
  if (isActive) {
    activeSubmenuId.value = null
  } else {
    activeSubmenuId.value = menuId

    // Calculate container height if not already calculated
    if (!containerHeights.value[menuId]) {
      await nextTick()
      const container = (event.currentTarget as HTMLElement).nextElementSibling as HTMLElement
      if (container) {
        containerHeights.value[menuId] = container.scrollHeight + 'px'
      }
    }
  }
}
// Function to handle direct link clicks
const handleLinkClick = (menuItem: any) => {
  // If submenu is already open, navigate to URL
  if (menuItem.items && isSubmenuActive(menuItem.url)) {
    navigateTo(getMenuItemUrl(menuItem))
  }
}
// Calculate initial heights when component is mounted
onMounted(async () => {
  await nextTick()
  const menuItems = document.querySelectorAll('.menu-item')

  menuItems.forEach((menuItem, index) => {
    const container = menuItem.nextElementSibling as HTMLElement
    const menuItemData = mainMenuItems[index]

    if (container && menuItemData && menuItemData.url) {
      containerHeights.value[menuItemData.url] = container.scrollHeight + 'px'
    }
  })
})

const topOffset = useHeaderConfig().getStickyTopOffset()
const headerStickyTopOffsetMinWidth = Number(config.public.cncWrapper?.responsiveBreakpoint || 1080)


useHead({
  bodyAttrs: {
    class: computed(() => {
      if (isMegamenuActive.value) return 'overflow-hidden';

      return '';
    }),
  },
})

const checkSticky = () => {
  if (import.meta.client && window) {
    if (window?.innerWidth < headerStickyTopOffsetMinWidth) {
      isSticky.value = window.scrollY >= 0 // Adjust the threshold as needed
    } else {
      isSticky.value = window.scrollY >= topOffset // Adjust the threshold as needed
    }
  }
}

onMounted(() => {
  isWeb.value = !!window;

  checkSticky()

  const handleScroll = () => {
    checkSticky()
  }

  window.addEventListener("scroll", handleScroll)
  window.addEventListener("resize", handleScroll)
  document.addEventListener('click', checkSearchAndMenuState)

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll)
    window.removeEventListener("resize", handleScroll)
    document.removeEventListener('click', checkSearchAndMenuState)
  })

  // stories fullscreen event handle
  $listen('content:fullscreen', (isFullscreen) => {
    isHidden.value = !!isFullscreen
  })
})

const getMenuItemUrl = (menuItem: StaticMenuItem): string | undefined => {
  const pattern = /^((http|https|ftp):\/\/)/
  if (!menuItem.url) {
    return undefined
  }
  if (pattern.test(menuItem.url)) {
    return menuItem.url
  }
  return `/${menuItem.url}`
}

const getCurrentEditionImageSrc = () => {
  // return '/img/materidouska/nove-vydani-02-2025.png'
  return articleCurrentEditionStore.article?.previewAsset?.urlWithProtocol || '/img/materidouska/nove-vydani-02-2025.png'
}

const formSubmit = (event: any) => {
  isMegamenuActive.value = false;
  const path = localePath({ name: "search", query: { q: event.target.elements.q.value } });
  router.push(path)
}
const resetSearch = () => {
  inputModel.value = ''
}

watch(
  () => route.query,
  () => {
    inputModel = ref(String(route.query.q || ""));
  }
)

// menu and search open/close handle
const openMenu = () => {
  isMegamenuActive.value = true
  if (searchInputActive.value) {
    searchInputActive.value = false
  }
}

const handleHamburgerClick = () => {
  if (isMegamenuActive.value || searchInputActive.value) {
    closeSearchAndMenu()
  } else {
    openMenu()
  }
}

const openSearch = () => {
  searchInputActive.value = true
  nextTick(() => {
    // Now TypeScript knows that searchInput.value might be an HTMLInputElement
    // which has a focus() method
    searchInput.value?.focus()
  })
  if (isMegamenuActive.value) {
    isMegamenuActive.value = false
  }
}

const closeSearchAndMenu = () => {
  searchInputActive.value = false
  isMegamenuActive.value = false
}

const checkSearchAndMenuState = () => {
  if (isMegamenuActive.value || searchInputActive.value) {
    closeSearchAndMenu()
  }
}
</script>